import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ConfigService } from '../../../services/config/config.service';
import { ProductoService } from '../../../services/producto/producto.service';
import { ProveedorService } from '../../../services/proveedor/proveedor.service';
import { HttpErrorResponse } from '@angular/common/http';
import { AutoComplete } from 'primeng/autocomplete';
import { ListaPreciosService } from '../../../services/lista-precios/lista-precios.service';


@Component({
  selector: 'app-producto',
  templateUrl: './producto.component.html',
  styleUrls: ['./producto.component.scss'],
  standalone: false,
  providers: [MessageService, ConfirmationService]
})
export class ProductoComponent implements OnInit {

  loadMenu: boolean = true;
  load: boolean = false;
  message: string = "";
  messageInv: string = "";
  token: any = {};
  infoEmpresa: Array<any> = [];
  @ViewChild('autocomplete') autocomplete: AutoComplete | undefined;
  txtSearch: string = "";
  txtSearch2: string = "";
  categorias: Array<any> = [];
  showCategory: boolean = false;
  disabledCategory: boolean = false;
  nameCategory: string = "";
  selectedCategory: any = {};
  subCategorias: Array<any> = [];
  subCategoriasN3: Array<any> = [];
  subCategoriasN4: Array<any> = [];
  selectedSubCategory: any = {};
  selectedSubCategoryN3: any = {};
  selectedSubCategoryN4: any = {};
  showSubCategory: boolean = false;
  showSubCategoryN3: boolean = false;
  showSubCategoryN4: boolean = false;
  disabledSubCategory: boolean = false;
  disabledSubCategoryN3: boolean = false;
  disabledSubCategoryN4: boolean = false;
  nameSubCategory: string = "";
  nameSubCategoryN3: string = "";
  nameSubCategoryN4: string = "";
  estados: Array<any> = [];
  selectedState: any = {};
  showState: boolean = false;
  caracteristicas: Array<any> = [];
  selectedCharacteristic: Array<any> = [];
  showCharacteristic: boolean = false;
  filterCharacteristicArray: Array<any> = [];
  resultsSKU: any = [];
  resultsSKU2: any = [];
  sku: any = {};
  canDo: boolean = false;
  canUpdate: boolean = false;
  tiendas: Array<any> = [];
  uploadedFiles: Array<any> = [];
  multiple: boolean = true;
  formProducto = new FormGroup({
    identificador: new FormControl(0, { nonNullable: true, validators: [Validators.required] }),
    codigoBarras: new FormControl('', [Validators.required]),
    descripcionLarga: new FormControl('', [Validators.required, Validators.maxLength(200)]),
    descripcionCorta: new FormControl('', [Validators.required, Validators.maxLength(70)]),
    informacionAdicional: new FormControl('', [Validators.maxLength(2000)]),
    referencia: new FormControl('', [Validators.required]),
    marca: new FormControl('', [Validators.required]),
    unidadPresentacion: new FormControl('Unidad', { nonNullable: true, validators: [Validators.required] }),
    impuesto: new FormControl(19, { nonNullable: true, validators: [Validators.required] }),
    estado: new FormControl(true, [Validators.required]),
    publicado: new FormControl(false),
    isService: new FormControl(false),
    precioVenta: new FormControl(1000, { nonNullable: true, validators: [Validators.required] }),
    precioPromocion: new FormControl(1000, { nonNullable: true, validators: [Validators.required] }),
  });

  formSeo = new FormGroup({
    title: new FormControl("", [Validators.required]),
    slug: new FormControl("", [Validators.required]),
    meta: new FormControl("", [Validators.required])
  })
  arrayListaPrecios: Array<any> = [];
  @ViewChild('fileUpload') fileUpload: any;
  divCategorizacion: boolean = false;
  infProdBasic: boolean = true;
  lsInvCruzado: Array<any> = [];
  totalInventario: number = 0;
  timer: any | undefined;

  constructor(private producto: ProductoService, private proveedor: ProveedorService,
    private toast: MessageService,
    private router: ActivatedRoute,
    private config: ConfigService,
    private confirmacion: ConfirmationService,
    private listaPrecios: ListaPreciosService) {

  }

  ngOnInit(): void {
    this.token = JSON.parse(localStorage.getItem('token') ?? "".toString());
    this.infoEmpresa = JSON.parse(localStorage.getItem('empresa') ?? "[]");
    //leyendo los parametros
    this.router.params.subscribe((row: any) => {
      if (parseInt(atob(row.edit)) == 1)
        this.canUpdate = true;
    });

    // importar información principal
    this.load = true;
    this.producto.getCategorizacionNivel1(this.token.token).subscribe({
      next: (response) => {
        this.categorias = response as Array<any>;
        // import caracterpísticas
        this.producto.getCaracteristicas(this.token.token).subscribe((response) => {
          this.caracteristicas = response as Array<any>;
          this.producto.getEstadoProductos(this.token.token).subscribe((response) => {
            this.estados = response as Array<any>;
            this.load = false;
          });
        });
      }, error: (error: HttpErrorResponse) => { this.config.handleError(error); }
    });



  }

  // importar categorias de n niveles
  getCategoriaNivelN: any = (nivel: number, idCategoriaM: number) => {
    return new Promise((resolve, reject) => {
      if (!!idCategoriaM)
        this.producto.getCategorizacionNivelN(this.token.token, idCategoriaM).subscribe({
          next: (response) => {
            switch (nivel) {
              case 2:
                this.subCategorias = response as Array<any>;
                this.subCategoriasN3 = [];
                this.subCategoriasN4 = [];
                break;
              case 3:
                this.subCategoriasN3 = response as Array<any>;
                this.subCategoriasN4 = [];
                break;
              case 4:
                this.subCategoriasN4 = response as Array<any>;
                break;
            }
            resolve(true);
          },
          error: (error: HttpErrorResponse) => { this.config.handleError(error) }
        });
    })

  }


  reload() {
    window.location.reload();
  }

  searchSKU = (event: any) => {
    this.message = "";
    this.formProducto.reset();
    this.selectedSubCategory = {};
    this.tiendas = [];

    window.clearTimeout(this.timer);

    this.timer = setTimeout(() => {
      if (event.query != "")
        this.producto.searchSKU(this.token.token, event.query).subscribe((response) => {
          this.resultsSKU = response as Array<any>;
          window.clearTimeout(this.timer);
          if (this.resultsSKU.length == 0) {
            this.sku = {
              codBarras: event.query
            };
            if (this.canUpdate) {
              this.message = "<div class='p-1 p-message p-message-success'> Si desea crear el producto, favor continue el proceso</div>"
              this.autocomplete?.hide();
              // si es numerico se deja en indetificador
              this.formProducto.controls.identificador.setValue(isNaN(parseInt(this.txtSearch)) ? 0 : parseInt(this.txtSearch));
            }
            else
              this.message = "<div class='p-1 p-message p-message-warn'> El producto relacionado no existe</div>"
          } this.canDo = true;
        });
      else
        this.message = "<div class='p-message p-message-error'> Favor relacione el identificador del producto</div>"
    }, 1200);


  }

  validateSelected = (event: any) => {
    if (!this.canUpdate)
      if (!this.sku.hasOwnProperty('idProducto'))
        this.message = "<div class='p-1 p-message p-message-warn'>Recuerde seleccionar el producto</div>"
      else this.message = '';
  }

  saveCategory = () => {
    // si se crear es activo
    var data: any = {};
    if (this.showCategory) {
      data = {
        idCategorizacionProveedor: this.showCategory ? 0 : this.selectedCategory?.idCategorizacionProveedor ?? 0,
        descripcion: this.nameCategory,
        posicion: 1,
        activo: true
      }
      this.nameCategory = "";
      this.showCategory = false;
    }
    else {
      data = this.selectedCategory;
      this.disabledCategory = false;
    }
    if (data.descripcion != "")
      this.producto.setCategoriaNivelN(this.token.token, data).subscribe((response) => {
        this.load = false;
        this.toast.add({ key: 'message', severity: 'success', summary: 'Confirmación', detail: 'Procesamiento exitoso' });
        this.producto.getCategorizacionNivel1(this.token.token).subscribe((response) => {
          this.categorias = response as Array<any>;
        });
      })
    else
      this.toast.add({ key: 'message', severity: 'danger', summary: 'Error', detail: 'El nombre de la categoria debe tener un dato' });

  }

  saveSubCategory = (nivel: number) => {
    var data: any = {};
    let showSubCategory = nivel == 2 ? this.showSubCategory : (nivel == 3 ? this.showSubCategoryN3 : this.showSubCategoryN4);

    if (showSubCategory) {
      data = {
        idCategorizacionProveedor: nivel == 2 && !showSubCategory ? this.selectedSubCategory.idCategorizacionProveedor : (nivel == 3 && !this.showSubCategoryN3 ? this.selectedSubCategoryN3.idCategorizacionProveedor : ((nivel == 4 && !this.showSubCategoryN4) ? this.selectedSubCategoryN4.idCategorizacionProveedor : 0)),
        idCategorizacionProveedorM: nivel == 2 ? this.selectedCategory.idCategorizacionProveedor : (nivel == 3 ? this.selectedSubCategory.idCategorizacionProveedor : this.selectedSubCategoryN3.idCategorizacionProveedor),
        posicion: nivel,
        descripcion: nivel == 2 ? this.nameSubCategory : (nivel == 3 ? this.nameSubCategoryN3 : this.nameSubCategoryN4),
        activo: true
      }
      // inactivando el check de la categoria N
      switch (nivel) {
        case 2:
          this.showSubCategory = false;
          break;
        case 3:
          this.showSubCategoryN3 = false;
          break;
        case 4:
          this.showSubCategoryN4 = false;
          break;
      }
    }
    else {
      data = nivel == 2 ? this.selectedSubCategory : (nivel == 3 ? this.selectedSubCategoryN3 : this.selectedSubCategoryN4);
      // inactivando el check de la categoria N
      switch (nivel) {
        case 2:
          this.disabledSubCategory = false;
          break;
        case 3:
          this.disabledSubCategoryN3 = false;
          break;
        case 4:
          this.disabledSubCategoryN4 = false;
          break;
      }
    }

    if (data.descripcion != "")
      this.producto.setCategoriaNivelN(this.token.token, data).subscribe((response) => {
        this.load = false;
        this.getCategoriaNivelN(nivel, data.idCategorizacionProveedorM);
        this.toast.add({ key: 'message', severity: 'success', summary: 'Confirmación', detail: 'Procesamiento exitoso' });
      })
    else
      this.toast.add({ key: 'message', severity: 'error', summary: 'Error', detail: 'El nombre de la subcategoria debe tener un dato' });
  }


  // al momento se seleccionar el SKU
  processSKU = (event: any) => {
    this.sku = event.value as object;
    this.message = '';

    this.listaPrecios.get(this.token.token).subscribe({
      next: (response) => {
        this.arrayListaPrecios = response as Array<any>;
        this.arrayListaPrecios.map((row: any) => {
          row.detalle = this.sku.detalleListaPrecios.filter((item: any) => item.idListaPrecios == row.idListaPrecios)[0];
          if (!row.detalle)
            row.detalle = {};
        });
      },
      error: (error: HttpErrorResponse) => { console.log(error) }
    })

    // conocer si existen categorias para el producto
    if (!this.sku.categorizacionProducto)
      this.toast.add({ key: 'message', severity: 'warn', detail: 'Favor seleccione la categorización a asignar para el producto existente' });
    else {
      // asignación de categorias
      let categorizacion = this.sku.categorizacionProducto.isStrcategorizacionProveedor.split('|').filter((row: any) => row != '');
      // categoria nivel 1
      this.selectedCategory = this.categorias.filter(row => row.idCategorizacionProveedor == categorizacion[0])[0];
      // categoria nivel 2
      this.getCategoriaNivelN(2, this.selectedCategory.idCategorizacionProveedor).then((response: any) => {
        this.selectedSubCategory = this.subCategorias.filter(row => row.idCategorizacionProveedor == categorizacion[1])[0];
        // categoria nivel 3
        if (categorizacion.length > 2)
          this.getCategoriaNivelN(3, this.selectedSubCategory?.idCategorizacionProveedor).then((response: any) => {
            this.selectedSubCategoryN3 = this.subCategoriasN3.filter(row => row?.idCategorizacionProveedor == categorizacion[2])[0];
            // categoria nivel 4
            if (categorizacion.length > 3)
              this.getCategoriaNivelN(4, this.selectedSubCategoryN3.idCategorizacionProveedor).then((response: any) => {
                this.selectedSubCategoryN4 = this.subCategoriasN4.filter(row => row?.idCategorizacionProveedor == categorizacion[3])[0];
              });
          });
      });


    }
    // actualizando la ruta para las imagenes
    this.sku.productoImagenes.map((item: any) => {
      item.ubicacion = this.config.urlIMG + item.ubicacion;
    })

    this.formProducto.controls["codigoBarras"].setValue(this.sku.codBarras);
    this.formProducto.controls["descripcionCorta"].setValue(this.sku.descripcionCorta);
    // si no hay nada en SEo se coloca la descripción como slug

    this.formProducto.controls["descripcionLarga"].setValue(this.sku.descripcionLarga);


    this.formProducto.controls["estado"].setValue(this.sku.idProductoEstado);
    this.formProducto.controls["identificador"].setValue(this.sku.identificador);
    this.formProducto.controls["impuesto"].setValue(this.sku.impuesto);
    this.formProducto.controls["marca"].setValue(this.sku.marca);
    if (!this.sku.precioProducto)
      this.sku.precioProducto = {
        precioProducto: 0,
        precio: 0
      }
    this.formProducto.controls["precioVenta"].setValue(this.sku.precioProducto.precio);
    this.formProducto.controls["precioPromocion"].setValue(this.sku.precioProducto.precioPromocion);
    this.formProducto.controls["publicado"].setValue(this.sku.precioProducto.publicado)
    this.formProducto.controls["referencia"].setValue(this.sku.referencia);
    this.formProducto.controls["unidadPresentacion"].setValue(this.sku.unidadPresentacion);
    this.formProducto.controls["estado"].setValue(this.sku.activo);
    this.formProducto.controls.isService.setValue(this.sku.categorizacionProducto.isServicio);
    this.formProducto.controls["informacionAdicional"].setValue(this.sku.informacionProducto?.informacion ?? "");

    this.selectedCharacteristic = this.sku.caracteristicasProductos.map((row: any) => {
      return {
        "idProducto": this.sku.idProducto,
        "idCaracteristica": row.idCaracteristica,
        "nombreCaracteristica": row.idCaracteristicaNavigation.nombreCaracteristica,
        "valor": row.valor

      }
    });

    // asignar propiedades SEO
    this.formSeo.controls.title.setValue(this.resultsSKU[0].informacionProducto?.titleSeo ?? '');
    this.formSeo.controls.meta.setValue(this.resultsSKU[0].informacionProducto?.metaDescription ?? '');
    this.formSeo.controls.slug.setValue((this.formProducto.controls.descripcionCorta.value ?? "").trim().split(' ').join('-').toLowerCase());
  }

  createSKU = () => {
    if (this.infProdBasic
      && ((this.formProducto.controls.identificador.value ?? 0) > 0)
      && ((this.formProducto.controls.descripcionCorta.value ?? '') != '')
      && ((this.formProducto.controls.unidadPresentacion.value ?? '') != '')
      && ((this.formProducto.controls.impuesto.value ?? 0) > 0)
      && ((this.formProducto.controls.precioVenta.value ?? 0) > 0)
    ) {
      // complemento de campos para proceder con la creación
      if ((this.formProducto.controls.descripcionLarga.value ?? '') == '')
        this.formProducto.controls.descripcionLarga.setValue(this.formProducto.controls.descripcionCorta.value ?? '');
      if ((this.formProducto.controls.referencia.value ?? '') == '')
        this.formProducto.controls.referencia.setValue((this.formProducto.controls.identificador.value ?? 0).toString());
      if ((this.formProducto.controls.codigoBarras.value ?? '') == '')
        this.formProducto.controls.codigoBarras.setValue((this.formProducto.controls.identificador.value ?? 0).toString());
      this.formProducto.controls.precioPromocion.setValue((this.formProducto.controls.precioVenta.value ?? 0));
      this.create();
    }
    else if (this.infProdBasic) {
      this.toast.add({ key: 'message', severity: 'error', summary: 'Error', detail: 'Favor ingrese la información para proceder con la creación' });
    }
    else {
      if (this.formProducto.valid) {
        this.create();
      }
      else
        this.toast.add({ key: 'message', severity: 'error', summary: 'Error', detail: 'Favor ingrese la información para proceder con la creación' });
    }
  }

  create = () => {
    this.load = true;
    const data = {
      idProducto: this.sku.idProducto ?? 0,
      activo: true,
      codBarras: this.formProducto.controls["codigoBarras"].value,
      descripcionCorta: this.formProducto.controls["descripcionCorta"].value,
      descripcionLarga: this.formProducto.controls["descripcionLarga"].value,
      idProductoEstado: this.formProducto.controls["estado"].value ? 1 : 2,
      idProveedor: this.infoEmpresa[0].idProveedor,
      idUser: this.infoEmpresa[0].idEmpleado,
      identificador: this.formProducto.controls["identificador"].value,
      impuesto: this.formProducto.controls["impuesto"].value,
      marca: this.formProducto.controls["marca"].value,
      precioProducto: {
        idPrecioProducto: this.sku.idProducto ?? 0 > 0 ? this.sku.precioProducto.idPrecioProducto : 0, idProducto: this.sku.idProducto ?? 0, precio: this.formProducto.controls["precioVenta"].value, precioPromocion: this.formProducto.controls["precioPromocion"].value,
        publicado: this.formProducto.controls["publicado"].value ?? false
      },
      referencia: this.formProducto.controls["referencia"].value,
      unidadPresentacion: this.formProducto.controls["unidadPresentacion"].value,
      fechaCreacion: this.sku.fechaCreacion ?? null,
      informacionProducto: (this.formProducto.controls["informacionAdicional"].value ?? "") == "" ? null : {
        idInformacionProducto: this.sku.informacionProducto.idInformacionProducto ?? 0,
        idProducto: this.sku.informacionProducto.idProducto,
        informacion: this.formProducto.controls["informacionAdicional"].value ?? ''
      },
      "categorizacionProducto": {
        "idCategorizacionProducto": this.sku.idProducto?.idCategorizacionProducto ?? 0,
        "idProducto": this.sku.idProducto,
        "isServicio": this.formProducto.controls.isService.value ?? false,
        "isStrcategorizacionProveedor": this.selectedCategory.idCategorizacionProveedor + '|' +
          this.selectedSubCategory.idCategorizacionProveedor + '|' +
          ((this.selectedSubCategoryN3?.idCategorizacionProveedor ?? 0) > 0 ? this.selectedSubCategoryN3?.idCategorizacionProveedor + '|' : '') +
          ((this.selectedSubCategoryN4?.idCategorizacionProveedor ?? 0) > 0 ? this.selectedSubCategoryN4?.idCategorizacionProveedor + '|' : '')
      }
    }
    this.producto.setSKU(this.token.token, data).subscribe({
      next: (response) => {
        this.formProducto.reset();
        this.txtSearch = "";
        this.message = "";
        this.resultsSKU = [];

        this.toast.add({ key: 'message', severity: 'success', summary: 'Confirmación', detail: 'Procesamiento exitoso' });
        // reset formulario
        this.selectedCategory = {};
        this.selectedSubCategory = {};
        this.selectedSubCategoryN3 = {};
        this.selectedSubCategoryN4 = {};
        this.selectedCharacteristic = [];
        this.load = false;
        this.sku = {};
      }, error: (error: HttpErrorResponse) => {
        console.log('error:', error);
        this.toast.add({ key: 'message', severity: 'error', summary: 'Confirmación', detail: 'Se ha presentado un error, favor intente nuevamente' });
        this.load = false;
      }
    })
  }

  filterCharacteristic = (event: any) => {
    this.filterCharacteristicArray = this.caracteristicas.filter((row) => { return row.nombreCaracteristica.toLowerCase().indexOf(event.query) > -1 });
  }

  setCaharacteristics = () => {
    const data = this.selectedCharacteristic.map((row: any) => {
      return {
        "idProducto": this.sku.idProducto,
        "idCaracteristica": row.idCaracteristica,
        "valor": row.valor
      }
    });
    this.producto.setCaracteristicas(this.token.token, data).subscribe((response) => {
      this.toast.add({ key: 'message', severity: 'success', summary: 'Confirmación', detail: response.toString() });
    })
  }
  // cargar inventario
  tabChange = (event: any) => {
    if (event.index == 3)

      if (!!this.sku.idProducto) {
        this.totalInventario = 0;
        this.messageInv = "<div class='p-message p-message-success'> Cargando ...</div>"
        this.proveedor.getInventarioTiendas(this.token.token, this.infoEmpresa[0].idProveedor, this.sku.idProducto)
          .subscribe((response) => {
            this.tiendas = response as Array<any>;
            this.tiendas.map((row: any) => {
              this.totalInventario = row.tiendaProductos[0].cantidadEnMano +
                row.tiendaProductos[0].cantidadMasiva + this.totalInventario;
            })

            this.messageInv = "";
          });
      }
  }

  onUpload(event: any) {
    var x = 0;
    for (let file of event.files) {
      const formData = new FormData;
      formData.append('file', file, file.name);
      this.uploadedFiles.push(formData);
      this.producto.setPhotos(this.token.token, formData, this.infoEmpresa[0].idProveedor, this.sku.idProducto, x++).subscribe((response) => {
        let img = JSON.parse(response as any);
        img.ubicacion = this.config.urlService + "Resources/Imagenes/" + img.ubicacion;
        this.sku.productoImagenes.push(img);
        this.toast.add({ key: 'message', severity: 'info', summary: 'Archivo cargado', detail: '' });
      });
    }
    this.fileUpload.clear();
  }


  updateAttrImg = (index: number) => {
    this.producto.updatePhotos(this.token.token, this.sku.productoImagenes[index]).subscribe((response) => {
      this.toast.add({ key: 'message', severity: 'info', summary: response.toString(), detail: '' });
      this.sku.productoImagenes[index].message = "<div class='p-message p-message-success'>" + response.toString() + "</div>";
    });
  }

  // fijar el precio
  setPrice = (row: any) => {
    if ((row.detalle.precio >= 0 && row.detalle.precioPromocion >= 0 && row.detalle?.idDetalleListaPrecios > 0) ||
      (row.detalle.precio > 0 && row.detalle.precioPromocion > 0 && (row.detalle?.idDetalleListaPrecios ?? 0) == 0)) {
      const data = {
        "idDetalleListaPrecios": row.detalle?.idDetalleListaPrecios ?? 0,
        "idListaPrecios": row.idListaPrecios,
        "idProducto": this.sku.idProducto,
        "precio": row.detalle.precio,
        "precioPromocion": row.detalle.precioPromocion,
      }
      this.listaPrecios.setItem(this.token.token, data).subscribe({
        next: (response) => {
          // actualizar el precio en pantalla
          this.formProducto.controls.precioPromocion.setValue(row.detalle.precioPromocion);
          this.formProducto.controls.precioVenta.setValue(row.detalle.precio);
          row.message = "<div class='p-message p-message-success'>Procesamiento exítoso</div>"
        },
        error: (error: HttpErrorResponse) => { row.message = "<div class='p-message p-message-error'>" + error.message + "</div>" }
      })
    } else {
      row.message = "<div class='p-message p-message-error'>Favor relacione los valores</div>"
    }
  }

  filterInvCruzado = (event: any) => {

    window.clearTimeout(this.timer);
    this.timer = setTimeout(() => {
      console.log('fitro', event);
      if (event.query != '')
        this.producto.searchSKU(this.token.token, event.query).subscribe((response) => {
          this.resultsSKU2 = response as Array<any>;
        });
      window.clearTimeout(this.timer);
    }, 1200);

  }

  addSKUInvCruzado = (event: any) => {
    console.log('Seleccion', event);
    if (this.lsInvCruzado.filter((row: any) => { return row.idProducto == event.value.idProducto }).length == 0) {
      this.lsInvCruzado.push(event.value);
      this.txtSearch2 = "";
      this.resultsSKU2 = [];
    }
    console.log(this.lsInvCruzado);
  }

  saveSEO = () => {
    if (this.formSeo.valid) {
      const data = {
        "idProducto": this.sku.idProducto,
        "slug": this.formSeo.controls.slug.value,
        "titleSeo": this.formSeo.controls.title.value,
        "metaDescription": this.formSeo.controls.meta.value,
      }
      this.producto.setInfoSEO(this.token.token, data).subscribe({
        next: (response) => { this.toast.add({ key: 'message', severity: 'success', summary: response as string }); },
        error: (error: HttpErrorResponse) => { console.log(error) }
      })
    }
    else {
      this.toast.add({ key: 'message', severity: 'warn', summary: 'Favor relacione la información solicitada' });
    }
  }



  confirm = (index: number) => {
    this.confirmacion.confirm({
      message: "¿Estas seguro de eliminar el item?",
      accept: () => {
        this.producto.deletePhotos(this.token.token, this.sku.productoImagenes[index], this.infoEmpresa[0].idProveedor).subscribe((response) => {
          this.toast.add({ key: 'message', severity: 'info', summary: response.toString(), detail: '' });
          this.sku.productoImagenes.splice(index, 1);
        });
      }
    })
  }


}
